import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../ui/button';

const InvalidSession: React.FC = () => {
    const navigate = useNavigate();
    return (
        <div className="min-h-screen flex items-center justify-center bg-[#FFF8F0]">
            <div className="text-center p-8">
                <AlertCircle className="w-16 h-16 mx-auto text-red-400 mb-4" />
                <h1 className="text-2xl font-bold text-gray-900 mb-2">Invalid Session</h1>
                <p className="text-gray-600 mb-6 max-w-md">
                    The session ID you provided is either incorrect or the session no longer exists.
                    Please check the link or return to the dashboard to start a new session.
                </p>
                <Button variant="destructive" onClick={() => navigate('/dashboard')}>
                    Back to Dashboard
                </Button>
            </div>
        </div>
    );
};

export default InvalidSession;
